import { User } from './auth.reducer';

import actionCreatorFactory from 'typescript-fsa';
const actionCreator = actionCreatorFactory('Auth');

export const login = actionCreator<{
  username: string;
  password: string;
}>('LOGIN');

export const loginSuccess = actionCreator<User>('LOGIN_SUCCESS');
export const tokenExpired = actionCreator<User>('TOKEN_EXPIRED');
export const resetAuth = actionCreator('RESET');



// WEBPACK FOOTER //
// ./src/store/Auth/auth.actions.ts